import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from '@/App'
import { getEnv } from '@/config/env'
import { BASE_PATH } from '@/config/paths'
import { configureAmplify } from '@/lib/auth/amplify'
import { queryClient } from '@/lib/query/query-client'
import '@/styles/globals.css'

getEnv()

configureAmplify()

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root element #root is missing from index.html')
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={BASE_PATH}>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
